<div class="animated fadeIn">
  <div class="row">
    <div class="col-lg-12">
      <div class="card mt-4">
        <div class="card-header">
          <i class="fas fas-align-justify"></i>
          Create Remove and Refit
        </div>
        <div class="card-body">
          <form [formGroup]="rRForm" class="needs-validation mt-4" novalidate>
            <div class="row">
              <div class="col-4">
                <labeled-display
                  [class]="'form-control'"
                  [name]="'Park'"
                  [value]="f.park.value"></labeled-display>
              </div>
              <div class="col-4">
                <labeled-display
                  [class]="'form-control'"
                  [name]="'Current Plot'"
                  [value]="f.currentPlot.value"></labeled-display>
              </div>
              <div class="col-4">
                <labeled-display
                  [class]="'form-control'"
                  [name]="'Current Square Feet'"
                  [value]="quote?.plans[0]?.planSquareFootage"></labeled-display>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                <labeled-input
                  [name]="'Destination Plot'"
                  [formName]="'destinationPlot'"
                  [form]="rRForm"
                  [type]="'text'"
                  [required]="true"
                  [class]="'form-control'"></labeled-input>
              </div>
              <div class="col">
                <labeled-input
                  [name]="'Comments'"
                  [formName]="'comments'"
                  [form]="rRForm"
                  [type]="'text'"
                  [required]="true"
                  [class]="'form-control'"></labeled-input>
              </div>

            </div>
            <div class="row">
              <div class="col d-flex justify-content-end">
                <button type="button" class="btn btn-success"
                        [swal]="{title: 'Prices could change when survey is carried out', showDenyButton: true}"
                        (confirm)="this.createRemoveAndRefit()">
                  Create Quote
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
